/*
 * @Author: your name
 * @Date: 2021-09-23 10:39:56
 * @LastEditTime: 2021-09-24 15:23:57
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\account\api.js
 */
export const api = {
  exitApproval: {
    queryAppointApprovalList: "/bms/vehicle/appointment/page.json", // 查询预约审批列表
    dispatchOutExamine: "/bms//vehicle/appointment/customerServiceOutExamine.json", // [客服出园审批] 不押车放行(8) 解押车放行(8)
    dispatchOutPauseCar: "/bms/vehicle/appointment/customerServiceOutPauseCar.json", // [客服出园审批] 客服押车不放行(7)
  },
};
